import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { Organization } from '../../types';
import { useNotification } from '../../context/NotificationContext';
import { organizationService } from '../../services';

interface UseCasesConfigCardProps {
  organization: Organization;
  onUpdate: (updatedOrg: Organization) => void;
}

const UseCasesConfigCard: React.FC<UseCasesConfigCardProps> = ({
  organization,
  onUpdate,
}) => {
  const { showNotification } = useNotification();
  const [saving, setSaving] = useState(false);

  // Verwende die Organization-Prop direkt als State-Quelle (Standard: deaktiviert)
  const usecasesEnabled = organization.usecases_enabled === true;
  
  const handleToggleChange = async (checked: boolean) => {
    if (saving) return; // Verhindere mehrfache Klicks während des Speicherns
    
    setSaving(true);
    
    try {
      const response = await organizationService.updateOrganization(organization._id, {
        usecases_enabled: checked
      });
      
      // Nur usecases_enabled aktualisieren, ohne Nutzer-Daten zu überschreiben
      onUpdate({
        ...organization,
        usecases_enabled: checked
      });
      showNotification(
        `Use Cases ${checked ? 'aktiviert' : 'deaktiviert'} für ${organization.name}`,
        'success'
      );
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Use Cases-Konfiguration:', error);
      showNotification(
        'Fehler beim Speichern der Use Cases-Konfiguration',
        'error'
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card sx={{ 
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        borderRadius: '8px',
        border: '1px solid rgb(0 0 0 / 0.05)',
        bgcolor: 'background.paper' ,
        minHeight: '150px'
      }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={usecasesEnabled}
                onChange={(e) => handleToggleChange(e.target.checked)}
                color="default"
                disabled={saving}
              />
            }
            label={
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Use Cases {usecasesEnabled 
                    ? 'aktiviert'
                    : 'deaktiviert'
                  }
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280' }}>
                  {usecasesEnabled 
                    ? 'Organisation kann Use Cases verwenden und erstellen'
                    : 'Use Cases-Funktionalität ist deaktiviert (Standard)'
                  }
                </Typography>
              </Box>
            }
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default UseCasesConfigCard;